<p>
    <span class="body-m-1">{{ showMore ? text : (text | slice : 0 : characterLimit) }}</span>
    <span *ngIf="!showMore && textExceedLimit" class="body-m-1">...</span>
</p>
<vc-button
    *ngIf="textExceedLimit"
    mode="text"
    [label]="showMore ? showLessLabel : showMoreLabel"
    (trigger)="showMore = !showMore; showMoreChange.emit(showMore)"></vc-button>
